import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../environments/environment';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storedDataRaw = sessionStorage.getItem(environment.storageName);
  const storedData = storedDataRaw ? JSON.parse(storedDataRaw) : null;
  const token = storedData?.token;

  if (token) {
    return true;
  }

  router.navigate(['/'], { queryParams: { redirectTo: state.url } });
  return false;
};

